export default {
  positionStart: {
    marginTop: '0 !important'
  }
};
